export const GREY = '#eef0f3'
export const GREY_DARKER = '#d7dce2'
